import { createCallchainHttp } from './callchain-http.js'

let http = null

export function configureModelCapabilityHttp(options) {
  http = createCallchainHttp({ ...options, basePath: '/api/admin/visual-game/model-capabilities' })
}

function modelCapabilityHttp() {
  if (!http) throw new Error('configureModelCapabilityHttp must be called before model capability API use')
  return http
}

export function fetchModelCapabilityCatalog() {
  return modelCapabilityHttp().get('', {
    routeId: 'GET /api/admin/visual-game/model-capabilities',
  })
}

export function saveModelProvider(input) {
  return modelCapabilityHttp().post('/providers', {
    body: input,
    routeId: 'POST /api/admin/visual-game/model-capabilities/providers',
  })
}

export function saveModelProviderCapability(input) {
  return modelCapabilityHttp().post('/provider-capabilities', {
    body: input,
    routeId: 'POST /api/admin/visual-game/model-capabilities/provider-capabilities',
  })
}

export function fetchProviderCapabilityKeys(providerCapabilityId) {
  return modelCapabilityHttp().get(`/provider-capabilities/${providerCapabilityId}/keys`, {
    routeId: 'GET /api/admin/visual-game/model-capabilities/provider-capabilities/:id/keys',
  })
}

export function saveProviderCapabilityKey(providerCapabilityId, input) {
  return modelCapabilityHttp().post(`/provider-capabilities/${providerCapabilityId}/keys`, {
    body: input,
    routeId: 'POST /api/admin/visual-game/model-capabilities/provider-capabilities/:id/keys',
  })
}

/** 服务凭据池（数字人 avatar:vidu、实时音视频 rtc:artc）：每个 vendor 一个池。 */
export function fetchServiceKeys() {
  return modelCapabilityHttp().get('/service-keys', {
    routeId: 'GET /api/admin/visual-game/model-capabilities/service-keys',
  })
}

export function saveServiceKey(vendor, input) {
  return modelCapabilityHttp().post(`/service-keys/${encodeURIComponent(vendor)}`, {
    body: input,
    routeId: 'POST /api/admin/visual-game/model-capabilities/service-keys/:vendor',
  })
}

export function deleteServiceKey(vendor, keyId) {
  return modelCapabilityHttp().post(`/service-keys/${encodeURIComponent(vendor)}/${keyId}/delete`, {
    routeId: 'POST /api/admin/visual-game/model-capabilities/service-keys/:vendor/:keyId/delete',
  })
}

export function deleteProviderCapabilityKey(providerCapabilityId, keyId) {
  return modelCapabilityHttp().post(`/provider-capabilities/${providerCapabilityId}/keys/${keyId}/delete`, {
    routeId: 'POST /api/admin/visual-game/model-capabilities/provider-capabilities/:id/keys/:keyId/delete',
  })
}

export function saveCapabilityModel(capability, input) {
  return modelCapabilityHttp().post(`/${capability}/models`, {
    body: input,
    routeId: `POST /api/admin/visual-game/model-capabilities/${capability}/models`,
  })
}

export function setCapabilityRoute(capability, modelId) {
  return modelCapabilityHttp().post(`/${capability}/route`, {
    body: { model_id: modelId },
    routeId: `POST /api/admin/visual-game/model-capabilities/${capability}/route`,
  })
}

export function saveTtsVoice(input) {
  return modelCapabilityHttp().post('/tts/voices', {
    body: input,
    routeId: 'POST /api/admin/visual-game/model-capabilities/tts/voices',
  })
}
